import { Box, Button, Tooltip, Typography } from "@mui/material"
import { EditOutlined, InfoOutlined } from "@mui-symbols-material/w300"
import { type FC, useState } from "react"
import { Controller, useFormContext } from "react-hook-form"

import { AS400_FIELD_MAX_LENGTH } from "./constants"

import { TextInput } from "@/components/Forms"

const AS400PreviewForm: FC = () => {
  const [disabled, setDisabled] = useState(true)

  const { control } = useFormContext()

  return (
    <>
      <Typography
        data-testid='location-address-details-form-title'
        variant='body1'
        fontWeight={700}
        className='h-9 leading-6 tracking-[0.15px] text-gray-700'
      >
        <Box className='flex items-center justify-between'>
          <Box className='flex items-center gap-1 space-x-2'>
            AS400 Translation Preview
            <Tooltip
              title={
                "This section shows how the data will look in AS400.  If the information doesn’t look correct in this section, you can either update the Location Details or directly edit the address below."
              }
              arrow
            >
              <Box className='flex items-center space-x-1'>
                <InfoOutlined fontSize='small' />
              </Box>
            </Tooltip>
          </Box>
          <Button endIcon={<EditOutlined />} onClick={() => setDisabled(false)} disabled={!disabled}>
            Edit
          </Button>
        </Box>
      </Typography>

      <Controller
        name='as400.name'
        control={control}
        render={({ field, fieldState: { error } }) => (
          <TextInput
            field={field}
            label='Name'
            required
            maxLength={AS400_FIELD_MAX_LENGTH.name}
            disabled={disabled}
            error={error}
          />
        )}
      />

      <Controller
        name='as400.address1'
        control={control}
        render={({ field, fieldState: { error } }) => (
          <TextInput
            field={field}
            label='Address line 1'
            required
            maxLength={AS400_FIELD_MAX_LENGTH.address1}
            disabled={disabled}
            error={error}
          />
        )}
      />

      <Controller
        name='as400.address2'
        control={control}
        render={({ field, fieldState: { error } }) => (
          <TextInput
            field={field}
            label='Address line 2'
            maxLength={AS400_FIELD_MAX_LENGTH.address2}
            disabled={disabled}
            error={error}
          />
        )}
      />

      <Controller
        name='as400.city'
        control={control}
        render={({ field, fieldState: { error } }) => (
          <TextInput
            field={field}
            label='City'
            required
            error={error}
            maxLength={AS400_FIELD_MAX_LENGTH.city}
            disabled={disabled}
          />
        )}
      />

      <Box className='flex w-full justify-between gap-4'>
        <Controller
          name='as400.regionIsoCode'
          control={control}
          render={({ field, fieldState: { error } }) => (
            <TextInput
              field={field}
              label='State'
              maxLength={AS400_FIELD_MAX_LENGTH.regionIsoCode}
              disabled={disabled}
              error={error}
            />
          )}
        />

        <Controller
          name='as400.postalCode'
          control={control}
          render={({ field, fieldState: { error } }) => (
            <TextInput
              field={field}
              label='ZIP Code (Postal Code)'
              maxLength={AS400_FIELD_MAX_LENGTH.postalCode}
              disabled={disabled}
              error={error}
            />
          )}
        />
      </Box>
    </>
  )
}

export default AS400PreviewForm
